import React from 'react';
import SEO from '../components/SEO';
import Hero from '../components/Hero';
import Services from '../components/Services';
import WhyUs from '../components/WhyUs';
import Stats from '../components/Stats';
import About from '../components/About';
import Contact from '../components/Contact';
import { organizationSchema, websiteSchema } from '../utils/structuredData';

const Home = () => {
  const combinedSchema = {
    "@context": "https://schema.org",
    "@graph": [organizationSchema, websiteSchema]
  };

  return (
    <>
      <SEO
        title="Tech Update - Flutter App Development & Website Development in Budget | Bhopal, Indore"
        description="Affordable Flutter app development and website development services in Bhopal, Indore, Delhi, Mumbai, Bangalore, and across India. Expert mobile app development, web development, WordPress development, and UI/UX design at budget-friendly prices."
        keywords="Flutter app development, website development in budget, mobile app development in Bhopal, web development in Indore, Flutter app development in Bhopal, Flutter app development in Indore, website development in Bhopal, website development in Indore, affordable app development, budget website development, mobile app development in Delhi, web development in Mumbai, Flutter development in Bangalore, app development company in Bhopal, web development company in Indore, Android app development, WordPress development, UI/UX design, React development, startup solutions, Kotlin, Java, React, Next.js, business solutions"
        url="https://www.gettechupdate.com"
        structuredData={combinedSchema}
      />
      <Hero />
      <Services />
      <WhyUs />
      <Stats />
      <About />
      <Contact />
    </>
  );
};

export default Home;

